import React from 'react'

// components
import {
  CButton,
  CRow,
} from '@coreui/react-pro'
import AppModal from '../AppModal'
import FormFileUpload from '../form/general-input-form/FormFileUpload'
import FormTextInput from '../form/general-input-form/FormTextInput'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'

// icons
import CIcon from '@coreui/icons-react'
import { cilWarning } from '@coreui/icons'

// styling
import { styleButtonVars3 } from '../custom-styles/buttonStyles'
import FormFileThumbnail from '../form/general-input-form/FormFileThumbnail'
import FormSelectInput from '../form/general-input-form/FormSelectInput'

const AppModalConfirmation = ({
  confirmationType,
  itemName,
  itemType,
  itemIndex,
  headerTitle,
  showModal,
  setShowModal,
  handleConfirmation,
  values,
  errors,
  handleChange,
  handleFileInput,
  handleSubmit,
  descriptionText,
  disabled,
  isLoading,
  handleSelectInput,
  gameOptions,
  voucherTypeOptions,
  handleConfirmDelete
}) => {

  return (
    <>
      {
        confirmationType === 'gamevoucher-bulk-import' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <CRow className='justify-content-center align-items-center'>
                <FormSelectInput
                  id='gamevoucher_game_value'
                  name='gamevoucher_game_value'
                  colSize='12'
                  inputLabel='Game Name'
                  className={"mb-3"}
                  selectOptions={gameOptions}
                  value={values.gamevoucher_game_value}
                  handleSelectInput={handleSelectInput}
                  feedbackInvalid={errors.gamevoucher_game_value}
                  invalid={errors.gamevoucher_game_value}
                  disabled={false}
                />
                {
                  values && values.files && Array.isArray(values.files) && values.files.length > 0 ? 
                  (
                    <FormFileThumbnail
                      name='files'
                      colSize='6'
                      files={values?.files}
                      className='justify-content-start align-items-center'
                      handleConfirmDelete={handleConfirmDelete}
                    />
                  ) : (
                    <FormFileUpload
                      name="files"
                      colSize='6'
                      handleFileInput={handleFileInput}
                      handleFileOnDrop={handleFileInput}
                      multiple={false}
                      invalid={errors?.files}
                      feedbackInvalid={errors?.files}
                      isSpesificImage={false}
                      maxFiles={1}
                    />
                  )
                }
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={() => handleConfirmation()}>
                  Submit
                </CButton>
              </>
            }
          />     
        )
      }
      {
        (
          confirmationType === 'clientvoucher-generate' ||
          confirmationType === 'clientvoucher-export'
        ) && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyDescription={
              <CRow className='justify-content-center align-items-center'>
                <FormSelectInput
                  id='clientvoucher_type'
                  name='clientvoucher_type'
                  colSize='6'
                  inputLabel='Voucher Type'
                  className='mb-3'
                  selectOptions={voucherTypeOptions}
                  value={values.clientvoucher_type}
                  handleSelectInput={(e) => handleSelectInput(e, confirmationType == 'clientvoucher-export' ? 'export' : 'generate')}
                  feedbackInvalid={errors.clientvoucher_type}
                  invalid={errors.clientvoucher_type}
                  disabled={false}
                />
                <FormTextInput 
                  id='clientvoucher_count'
                  name='clientvoucher_count'
                  colSize='6'
                  inputLabel='Count Voucher'
                  className='mb-3'
                  placeholder='Enter count voucher...'
                  value={values.clientvoucher_count}
                  handleTextInput={handleChange}
                  feedbackInvalid={errors?.clientvoucher_count}
                  invalid={errors?.clientvoucher_count}
                />
              </CRow>
            }
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={() => handleConfirmation()}>
                  {
                    confirmationType == 'clientvoucher-generate' ? 'Generate Now' : 'Export Now'
                  }
                </CButton>
              </>
            }
          />     
        )
      }
      {
        confirmationType === 'claimhistory-export' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitle={`Are you sure you want to export claim history?`}
            className={'text-center'}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  Cancel
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={() => handleConfirmation()}>
                  Export
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'delete-item' && (
          <AppModal
            showModal={showModal}
            setShowModal={setShowModal}
            bodyTitleIcon={<CIcon icon={cilWarning} size='8xl' />}
            bodyTitle={`Are you sure you want to delete this ${itemName}?`}
            bodyDescription={`Once confirmed, it can not be undo and all ${itemName} details will be deleted permanently.`}
            className={'text-center'}
            modalFooter={
              <>
                <CButton size='lg' color="secondary" onClick={() => setShowModal({ show: false, item: {} })}>
                  No
                </CButton>
                <CButton size='lg' style={styleButtonVars3} onClick={() => handleConfirmation(itemIndex, itemType)}>
                  Yes
                </CButton>
              </>
            }
          />
        )
      }
      {
        confirmationType === 'confirmation' && (
          <AppModal 
            showModal={showModal}
            setShowModal={setShowModal}
            headerTitle={headerTitle}
            bodyTitle={descriptionText}
            className={'text-center'}
            modalFooter={
              <>
                <ActionButtonForm 
                  isLoading={isLoading}
                  disabled={disabled}
                  onCancel={() => setShowModal({ show: false, item: {} })}
                  onSave={handleSubmit}
                />
              </>
            }
          />
        )
      }
    </>
  )
}

export default AppModalConfirmation
